import { memo } from 'react'
import { cn } from '~utils/cn'

interface ConcernTileProps {
  label: string
  keywords?: string
  icon?: string
  isSelected: boolean
  onSelect: () => void
}

/**
 * 주요 증상 고르기 타일 (DRT-7185, 디자인 "Concern Picker Options" B안).
 * 아이콘 32 + 이름(title-3) + 키워드(body-3). 좁은 화면에서는 말줄임 대신 두 줄까지 줄바꿈. 고르면 primary 테두리·배경
 */
const ConcernTile = memo(({ label, keywords, icon, isSelected, onSelect }: ConcernTileProps) => (
  <button
    type="button"
    aria-pressed={isSelected}
    className={cn(
      'flex-1 min-w-0 min-h-16 p-3 flex flex-row items-center rounded-xl text-start transition-colors duration-300',
      // 고른 칸은 색만이 아니라 테두리 두께(2px)로도 다르다: 오래된 웹뷰(Chrome 64, iOS 12.0~12.1)는
      // Tailwind 의 rgb 색을 못 읽는다. 바깥으로 1px 넓혀(-m-px) 안쪽 내용은 움직이지 않게 한다
      isSelected
        ? '-m-px border-2 border-primary-500 bg-primary-50 dark:border-primary-400 dark:bg-primary-900'
        : 'border border-gray-300 bg-white dark:border-gray-800 dark:bg-gray-900'
    )}
    onClick={onSelect}
  >
    {icon && (
      // 기존 증상 아이콘은 흰 둥근 사각 배경이 그려져 있어 모든 아이콘을 같은 흰 칸에 올린다
      // (고른 칸·다크 모드에서도 아이콘 모양이 같고, 남색 선이 어두운 배경에 묻히지 않는다)
      <span className="size-8 mr-2 shrink-0 overflow-hidden rounded-lg bg-white">
        <img className="size-8" src={icon} alt="" aria-hidden />
      </span>
    )}
    <span className="flex flex-col min-w-0 flex-1">
      <span className="text-title-3 text-gray-900 dark:text-white line-clamp-2">{label}</span>
      {keywords && (
        <span className="text-body-3 text-gray-700 dark:text-gray-500 line-clamp-2">
          {keywords}
        </span>
      )}
    </span>
  </button>
))

ConcernTile.displayName = 'ConcernTile'

export default ConcernTile
